export const PAID_DAYS = year => `/paid_days/${year}/`;
